import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Travel from '../views/Travel.vue'
import Me from '../views/Me.vue'
import map from '../views/Map.vue'
import ToolsBox from '../views/ToolsBox.vue'

import ContinentBrowser from '../views/browser/Continent';
import CountriesBrowser from '../views/browser/Countries';
import ArticlesBrowser from '../views/browser/Articles';
import Article from '../views/browser/Article';
import Adventure from '../views/Adventure';
import Dashboard from '../views/dashboard/Dashboard';
import Menu from '../views/dashboard/Menu';
import ArticleEditor from '../views/dashboard/ArticleCreation';
import AdventureEditor from '../views/dashboard/AdventureCreation';
import ToolBoxEditor from '../views/dashboard/ToolBoxEditor';
import ToolBoxDisplay from '../views/ToolBoxDisplay';
import MeEditor from '../views/dashboard/MeCreation'
import Login from '../views/Login'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    children: [
      {
        path: '',
        name: 'menu',
        component: Menu,
      },
      {
        path: 'article',
        name: 'article2',
        props: true,
        component: ArticleEditor,
      },
      {
        path: 'adventure',
        name: 'adventureEditor',
        props: true,
        component: AdventureEditor,
      },
      {
        path: 'toolbox',
        props: true,
        name: 'toolboxeditor',
        component: ToolBoxEditor,
      },
      {
        path: 'me',
        name: 'meeditor',
        component: MeEditor,
      }
    ]
  },
  {
    path: '/me',
    name: 'me',
    component: Me
  },
  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: Login
  },
  {
    path: '/adventure',
    name: 'adventure',
    component: Adventure
  },
  {
    path: '/toolsbox',
    name: 'toolbox',
    component: ToolsBox
  },
  {
    path: '/toolsboxDisplay',
    name: 'toolboxdisplay',
    props: true,
    component: ToolBoxDisplay
  },
  {
    path: '/travel',
    name: 'travel',
    component: Travel
  },
  {
    path: '/article',
    name: 'article',
    component: Article
  },
  {
    path: '/map',
    name: 'map',
    component: map,
    children: [{
      path: '',
      name: 'continent',
      component: ContinentBrowser
    },
    {
      path: 'countries',
      name: 'countries',
      component: CountriesBrowser
    },
    {
      path: 'articles',
      name: 'articles',
      component: ArticlesBrowser
    }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return new Promise((resolve, ) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  }

})

export default router
